export default __webpack_public_path__ + "2e6794dea12678710ba81216f064eec2.png";